import React from 'react';

import { Action } from '@bypasslane/clover--web-lib-sprout-action';
import { Banner } from '@bypasslane/clover--web-lib-sprout-banner';
import { FormGroup } from '@bypasslane/clover--web-lib-sprout-form-group';
import { Heading } from '@bypasslane/clover--web-lib-sprout-heading';
import { TextField } from '@bypasslane/clover--web-lib-sprout-text-field';
import PropTypes from 'prop-types';

import { withAuthLayout } from '../../../layouts/Auth';

const ForgotPasswordForm = ({
  register,
  handleSubmit,
  onSubmit,
  errors,
  pending,
  submitted,
  apiError
}) => {
  const Legend = () => (
    <Heading headingLevel="h3" className="mb-6">
      Forgot Password
    </Heading>
  );

  if (submitted) {
    return (
      <Banner
        className="mb-4 px-2 text-left"
        variant="success"
        title="Password reset email sent"
        closeable={false}
      >
        <span className="text-sm">
          Please check your email for instructions on how to reset your password.
        </span>
      </Banner>
    );
  }

  return (
    <div className="w-full md:w-[30rem] max-w-full align-middle justify-center">
      <FormGroup errorText={apiError} legend={<Legend />} isLegendVisible className="">
        <TextField
          className="p-2"
          label="Email"
          errorText={errors?.email?.message}
          {...register('email')}
        />

        <Action
          className="reset-password__action mt-4"
          variant="primary"
          loading={pending}
          onClick={handleSubmit(onSubmit)}
          fullwidth
          type="button"
        >
          Request Password Reset
        </Action>
      </FormGroup>
    </div>
  );
};

export default withAuthLayout(ForgotPasswordForm, { enableErrorBoundary: true });
ForgotPasswordForm.propTypes = {
  register: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.object,
  pending: PropTypes.bool.isRequired,
  resetPasswordResponse: PropTypes.object,
  resetPasswordError: PropTypes.object,
  submitted: PropTypes.bool,
  apiError: PropTypes.string
};
